import React from 'react';
import FadeIn from '../components/ui/FadeIn';
import Button from '../components/ui/Button';

const StudioRental = () => {
  return (
    <div className="pt-40 pb-40 bg-brand-ivory">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center mb-40">
          <FadeIn>
            <h1 className="text-6xl md:text-[8rem] font-heading leading-[0.85] mb-12 tracking-tighter">
              A space built <br /><span className="serif-italic text-brand-orange">for creation.</span>
            </h1>
            <p className="text-xl text-brand-teal/80 leading-relaxed mb-12 max-w-lg">
              Our studio is available for creators, brands, and photographers who need a clean, flexible environment for photo shoots, video content, and brand sessions.
            </p>
            <div className="p-10 bg-white rounded-3xl border border-brand-teal/5 flex items-center justify-between mb-12">
              <div>
                <p className="text-[10px] font-bold tracking-widest uppercase text-brand-teal/40 mb-1">Rental Rate</p>
                <p className="text-4xl font-serif italic text-brand-orange">$70/hour</p>
              </div>
              <Button href="https://lbbrandhaus.nuvoro.net/business/lbbrandhaus/service/studio-rental" variant="accent">Book Studio Time</Button>
            </div>
          </FadeIn>
          <FadeIn direction="left" className="image-zoom-container aspect-square">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/9c5adfa6bba615730f4558013336717062b18ab46d11ed47c31c88c932e61ffbf11018f89f2243f6aef891f7c9f9eda4/images/aW1hZ2UvanBlZw==/377b0c2917a996a8909e37a9d836ef43.jpg" 
              alt="Studio Interior" 
              className="w-full h-full object-cover" 
            />
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
          {['Photo Shoots', 'Video Content', 'Brand Sessions'].map((item, i) => (
            <FadeIn key={item} delay={i * 0.1} className="py-12 border-t border-brand-teal/10">
              <h3 className="text-2xl font-heading mb-4">{item}</h3>
              <p className="text-sm opacity-60 uppercase tracking-widest">Designed for Impact</p>
            </FadeIn>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StudioRental;